import TrustBundleService from 'src/services/TrustBundleService'
import { FOOTER_TRUST_MARKERS_COMBINATION_ID } from 'src/common/constants/footerTrustMarkers'
import logger from 'src/common/logger'

/** Single cached GraphQL fetch for _app trust marker providers. */
export async function getAppTrustMarkers(preview = false) {
  try {
    const payload = await TrustBundleService.getInstance().getFullSsrPayload(
      preview,
      FOOTER_TRUST_MARKERS_COMBINATION_ID
    )

    return {
      trustMarkers: payload.markers,
      footerTrustMarkersCombination: payload.footerCombination,
    }
  } catch (error) {
    logger.error('getAppTrustMarkers: fetch failed', { error })

    return {
      trustMarkers: [],
      footerTrustMarkersCombination: null,
    }
  }
}
